import { useAsync } from 'core/ui/hooks/useAsync'

import { type EffectiveCarrier } from '../../domain/Shipment'
import { createAssetCarrier } from '../../use-cases/createAssetCarrier'
import { updateAssetCarrier } from '../../use-cases/updateAssetCarrier'

type SaveAssetCarrierParams = {
  isExistingAsset: boolean
  shipmentUUID: string
  effectiveCarrier: EffectiveCarrier
}

function saveAssetCarrier(params: SaveAssetCarrierParams) {
  const { isExistingAsset, ...rest } = params
  if (isExistingAsset) {
    return updateAssetCarrier(rest)
  }

  return createAssetCarrier(rest)
}

export function useSaveAssetCarrier() {
  const { call, result, status, error } = useAsync(saveAssetCarrier)

  return { saveAssetCarrier: call, result, requestStatus: status, error }
}
